import { z } from 'zod';
import type { BaseEntity } from './common';
import type { JobOrderAllowedGroup } from './jobOrderAllowedGroup';
import type { GroupWorker } from './groupWorker';

/**
 * Group - Gruppo di lavoro
 * Corrisponde al modello backend Group
 */
export interface Group extends BaseEntity {
	/** Nome del gruppo (max 100 caratteri) */
	name: string;
	/** Lista dei lavoratori nel gruppo (navigation property) */
	groupWorkers?: GroupWorker[];
	/** Lista degli ordini che utilizzano questo gruppo (navigation property) */
	orders?: JobOrderAllowedGroup[];
}

/**
 * Tipo per il risultato dell'autocomplete Groups
 * Corrisponde ai campi selezionati nella query OData: id, name
 */
export type GroupAutocompleteResult = Pick<Group, 'id' | 'name'>;

/**
 * Schema Zod per la validazione runtime dei Group
 */
export const GroupSchema = z.object({
	id: z.number(),
	name: z.string(),
	// Navigation properties opzionali (non validate in runtime)
	groupWorkers: z.array(z.any()).optional(),
	orders: z.array(z.any()).optional(),
});
